import Component from './Codes';

export default Component;
